import { ElementType, FC } from 'react';
import { Box, Flex, Skeleton, useBreakpointValue, Text } from '@chakra-ui/react';
import { RewardsActivityCardType, TransactionTypes } from '../../types/RewardsActivityCard';
import { CbRewardsActivityCardImage } from './CbRewardsActivityCardImage';
import { CbRewardsActivityCardTitle } from './CbRewardsActivityCardTitle';
import { CbRewardsActivityCardTransaction } from './CbRewardsActivityCardTransaction';
import { CbRewardsActivityCardDate } from './CbRewardsActivityCardDate';
import { CbRewardsActivityReason } from './CbRewardsActivityReason';
import { CbRewardsActivityCardAmount } from './CbRewardsActivityCardAmount';
import { CbButton } from '../..';
export interface CbRewardsActivityCardProps extends RewardsActivityCardType {
  id: number;
  isPending: boolean;
  isManageView?: boolean;
  titleHref?: string;
  titleAs?: ElementType;
  transactionType: RewardsActivityCardType['transactionType'];
  purchaseInformation?: {
    denomination: string;
    discount: number;
    fee: number;
  };
  redemptionInformation?: {
    link: string;
    secret_code?: string;
    email?: string;
    isCompanyReward: boolean;
    isStripeReward: boolean;
  };
  onClick?: (id: number, image?: string) => void;
}
export const CbRewardsActivityCard: FC<CbRewardsActivityCardProps> = ({
  amount,
  createdAt,
  id,
  imageUrl,
  isPending,
  isManageView,
  reason,
  source,
  titleHref,
  titleAs,
  transactionType,
  purchaseInformation,
  redemptionInformation,
  onClick
}) => {
  const isMobile = useBreakpointValue({
    base: true,
    lg: false
  });
  const spacing = isMobile ? 4 : 6;
  // Is this ever false? Should we keep this?
  const isLinkDeliveryReward = !!redemptionInformation?.link;
  const isCompanyReward = redemptionInformation?.isCompanyReward;
  const handleRedemptionClick = () => {
    redemptionInformation && onClick && onClick(id, imageUrl);
  };
  const renderDeliverySource = () => {
    if (isLinkDeliveryReward || isCompanyReward) {
      return <CbButton onClick={handleRedemptionClick} size="sm">
          {isCompanyReward ? 'View' : 'Redeem'}
        </CbButton>;
    }
    if (!!redemptionInformation?.isStripeReward) {
      return <Text textAlign="right">{'Reward sent to linked payment method'}</Text>;
    }
    return <Text textAlign="right" data-sentry-element="Text" data-sentry-component="renderDeliverySource" data-sentry-source-file="CbRewardsActivityCard.tsx">
        {'Reward sent to '}
        <Text color="chonky.700" as="span" data-sentry-element="Text" data-sentry-source-file="CbRewardsActivityCard.tsx">
          {redemptionInformation?.email}
        </Text>
      </Text>;
  };
  return <>
      <Box borderRadius={24} backgroundColor={isPending ? 'transparent' : 'white'} boxShadow="standardCard" overflow="hidden" position="relative" data-sentry-element="Box" data-sentry-source-file="CbRewardsActivityCard.tsx">
        {isPending ? <Skeleton data-testid="skeleton" height={isMobile ? '160px' : '128px'} width="100%" /> : <Box padding={spacing}>
            <Flex justifyContent="space-between">
              <Flex>
                <CbRewardsActivityCardImage imageUrl={imageUrl} transactionType={transactionType} marginRight={isMobile ? 4 : 6} />
                <Box>
                  <CbRewardsActivityCardTitle amount={amount} source={source} purchaseInformation={purchaseInformation} transactionType={transactionType} titleHref={titleHref} titleAs={titleAs} marginTop={isMobile ? 1 : 0} marginBottom={isMobile ? 1 : 2} />
                  <Flex alignItems="center">
                    {!isMobile && <CbRewardsActivityCardTransaction transactionType={transactionType} />}
                    <CbRewardsActivityCardDate createdAt={createdAt} />
                  </Flex>
                  {reason && !isMobile && <CbRewardsActivityReason isMobile={isMobile} marginTop={3} maxWidth="550px" reason={reason} />}
                </Box>
              </Flex>
              {amount && !isMobile && <Flex direction="column" justifyContent="space-between" alignItems="flex-end">
                  <CbRewardsActivityCardAmount amount={amount} discount={purchaseInformation?.discount} transactionType={transactionType} />
                  {transactionType === TransactionTypes.StorePurchase && !isManageView && renderDeliverySource()}
                </Flex>}
            </Flex>
            {isMobile && <Box>
                {reason && <CbRewardsActivityReason isMobile={isMobile} marginTop={3} reason={reason} />}
                <Flex alignItems="center" justifyContent="space-between" marginTop={6}>
                  <CbRewardsActivityCardTransaction transactionType={transactionType} />
                  <Box>
                    {amount && <CbRewardsActivityCardAmount amount={amount} transactionType={transactionType} />}
                    {transactionType === TransactionTypes.StorePurchase && isLinkDeliveryReward && <CbButton onClick={handleRedemptionClick}>
                          {'Redeem'}
                        </CbButton>}
                  </Box>
                </Flex>
              </Box>}
          </Box>}
      </Box>
    </>;
};